cb.define([], function () {
  var ST_st_storecheckprepare_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		let gridModel = viewmodel.getGridModel();
	  	gridModel.on('beforeLoad', function (data){
			data.isDistinct = true;
		});
    },
 
  }
  try {
    module.exports = ST_st_storecheckprepare_VM_Extend;
  } catch (error) {

  }
  return ST_st_storecheckprepare_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckpreparelist_VM.Extend.js